<div
    class="tw-rounded-[10px] tw-p-[20px] tw-bg-[#C7EBFF3D] tw-border tw-border-[#6D7A873D] tw-pt-[10px] tw-pl-[10px] tw-pr-[10px] lg:tw-pb-[20px] md:tw-pb-[15px] tw-flex tw-flex-col tw-items-center tw-text-center lg:tw-gap-[19px] md:tw-gap-[15px] tw-gap-[20px] tw-h-full tw-break-words tw-whitespace-normal"
>
    <ng-container *ngIf="image">
        <div
            class="tw-w-full lg:tw-h-[130px] md:tw-h-[80px] tw-bg-white tw-border-1 tw-border-[#0000001A] tw-p-[25px] tw-flex tw-items-center tw-justify-center tw-rounded-[10px] tw-overflow-hidden"
        >
            <img
                [src]="image"
                [alt]="title"
                class="tw-w-full tw-h-full tw-object-contain tw-rounded-md"
            />
        </div>
    </ng-container>
    <div
        class="tw-flex tw-flex-col tw-gap-[14px] tw-items-center tw-justify-start w-full tw-flex-grow"
    >
        <span class="tw-text-black tw-font-bold tw-text-[16px]">
            {{ title }}
        </span>
        <span
            class="tw-text-black tw-text-[14px] tw-font-normal default-html"
            [innerHTML]="description"
        ></span>
    </div>

    <!-- <hr class="tw-w-full tw-border-2 tw-border-[#000]" /> -->
    <button
        [attr.ga-event-id]="ga?.id"
        [attr.ga-event-category]="ga?.category"
        [attr.ga-event-label]="ga?.label"
        ga-track="track"
        class="tw-w-[80%] md:tw-w-[100%] md:tw-px-[24px] tw-py-[10px] tw-bg-[#024B3F] tw-rounded-[32px]"
        (click)="onButtonClick()"
    >
        <span
            class="tw-text-white lg:tw-text-[16px] md:tw-text-[14px] tw-font-semibold tw-pointer-events-none"
            >{{ buttonText }}</span
        >
    </button>
</div>
